import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type {
  CustomerRequest,
  CustomerResponse,
  WalletTransactionRequest,
  WalletTransactionResponse,
} from '@/types/customer';

export const customersApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<CustomerResponse>>>('/v1/customers', { params })),

  get: (id: number) => unwrap(api.get<ApiResponse<CustomerResponse>>(`/v1/customers/${id}`)),

  create: (body: CustomerRequest) =>
    unwrap(api.post<ApiResponse<CustomerResponse>>('/v1/customers', body)),

  update: (id: number, body: CustomerRequest) =>
    unwrap(api.put<ApiResponse<CustomerResponse>>(`/v1/customers/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/customers/${id}`)),

  activate: (id: number, active: boolean) =>
    unwrap(
      api.patch<ApiResponse<CustomerResponse>>(`/v1/customers/${id}/activate`, null, {
        params: { active },
      }),
    ),

  walletTransaction: (id: number, body: WalletTransactionRequest) =>
    unwrap(
      api.post<ApiResponse<WalletTransactionResponse>>(`/v1/customers/${id}/wallet`, body),
    ),

  walletHistory: (id: number) =>
    unwrap(api.get<ApiResponse<WalletTransactionResponse[]>>(`/v1/customers/${id}/wallet/transactions`)),

  listContacts: (params?: SearchParams) =>
    unwrap(
      api.get<
        ApiResponse<
          PageResponse<{
            id: number;
            customerId?: number;
            customerName?: string;
            firstName?: string;
            lastName?: string;
            email?: string;
            phone?: string;
            jobTitle?: string;
            primaryContact?: boolean;
          }>
        >
      >('/v1/customers/contacts', { params }),
    ),
};
